export default {
explore_by: "按…探索",
explore_by_concepts: "创意",
explore_by_families: "香调家族",
language: "语言",
legal: "法律信息",
find_any_fragrance: "查找世界上的任何香水。",
title_by_concepts: "按创意探索",
desc_by_concepts: "通过想象你喜欢的颜色或地方找到你的香水",
title_by_families: "按香调家族探索",
desc_by_families: "通过思考…找到你的香水",
expert_reviewed: "专家评审",
ingredients: "成分",
description: "描述",
perfumist: "调香师",
concepts: "概念",
olfactive_family: "香调家族",
main_family: "家族",
sub_family: "子家族",
me_family: "世界香水",
filter_by_family: "家族",
filter_by_brand: "品牌",
filter_by_gender: "性别",
for_him: "男士",
for_her: "女士",
unisex: "中性",
all: "全部",
all_female: "全部",
concepts_list: "概念列表",
no_results_for_this_combination: "没有适合此组合的香水。",
select_at_least_one_concept: "请至少选择一个概念",
view_perfumes: "查看香水",
back: "返回",
close: "关闭",
filters: "筛选",
selected_concepts: "已选概念：",
selected_families: "已选家族：",
find_concept: "查找概念...",
smell_of: "带有…气息",
touch_of: "带有一丝",
loading_perfumes: "正在加载香水",
loading_concepts: "正在加载概念",
apply: "应用",
search: "搜索",
clear_all: "清除全部",
iconic_fragrances: "该家族中的经典香水",
is_there_anybody_here: "你还在吗？",
continue_previous_session: "是的！继续",
reset_session: "重新开始体验",
ingredient_type: "类型",
ingredient_parts: "使用部分",
ingredient_extraction: "萃取方法",
ingredient_first: "经典香水",
history: "历史",
effect: "生产与效果",
origin: "来源",
iconic_fragrance: "经典香氛",
production: "生产",
loyalty_become_a_member: "加入俱乐部",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"
}